<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button class="close" type="button" aria-label="Close" [disabled]="isBusy" (click)="activeModal.close(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form autofocus [formGroup]="form" (ngSubmit)="searchForm()">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-xl-4">
                <form-dropdown
                    labelText="{{ 'Line' | translate }}"
                    formControlName="line"
                    [observableInput]="line$"
                    [automaticPopulateWithFirstValue]="true"></form-dropdown>
            </div>
            @if (bookingVisible) {
                <div class="col-sm-6 col-md-4 col-xl-2">
                    <form-textbox
                        labelText="{{ 'Booking' | translate }} {{ showBookingOrBLAlert ? '*' : '' }}"
                        contextual="{{
                            showBookingOrBLAlert ? 'Enter one of the mandatory search criteria.' : ('' | translate)
                        }}"
                        formControlName="booking"></form-textbox>
                </div>
            }
            @if (bookingVisible) {
                <div class="col-sm-6 col-md-4 col-xl-2">
                    <form-textbox
                        labelText="{{ 'Release Order' | translate }}"
                        formControlName="releaseOrderNumber"
                        contextual="{{
                            releaseOrderTooltip
                                ? 'Enter release order only if you are requesting service for containers that were released to you by Line Agent.'
                                : ('' | translate)
                        }}"></form-textbox>
                </div>
            }
            <div class="col-sm-6 col-md-4 col-xl-2">
                <form-textbox
                    labelText="{{ 'Bill Of Lading' | translate }} *"
                    contextual="{{
                        (showBookingOrBLAlert
                            ? ('Enter one of the mandatory search criteria.' | translate) + ' '
                            : '') +
                            ('You can search for multiple bills of lading by entering their numbers, separated by a comma (e.g., MSKU123456789, MAEU987654321, ONEY765432109).'
                                | translate)
                    }}"
                    formControlName="billsOfLading"></form-textbox>
            </div>
            <div class="col-sm-6 col-md-4 col-xl-2">
                <form-textbox
                    labelText="{{ 'Container Number' | translate }} {{ isSocImportSearch ? '*' : '' }}"
                    contextual="{{
                        'You can search for multiple containers by entering their container numbers, separated by a comma (e.g., MEDU1234567, CMAU7654321, TCLU9876543).'
                            | translate
                    }}"
                    formControlName="containers"></form-textbox>
            </div>
            <div class="col-sm-6 col-md-4 col-xl-2">
                <form-dropdown
                    labelText="{{ 'F/E' | translate }}"
                    formControlName="fullOrEmpty"
                    codeListName="FullOrEmpty"></form-dropdown>
            </div>
            <div class="col-sm-6 col-md-4 col-xl-4">
                <form-dropdown
                    labelText="{{ 'Vessel' | translate }} {{ showBookingOrBLAlert && showVSOUTalert ? '*' : '' }}"
                    contextual="{{
                        showBookingOrBLAlert && showVSOUTalert
                            ? 'Enter one of the mandatory search criteria.'
                            : ('' | translate)
                    }}"
                    formControlName="vesselVisitId"
                    [observableInput]="vesselVisits$"
                    [automaticPopulateWithFirstValue]="true"></form-dropdown>
            </div>
            @if (!releaseOrderId && isVSOUTServiceRequest) {
                <div class="col-sm-6 col-md-4 col-xl-2">
                    <form-textbox
                        labelText="{{ 'Loading Voyage' | translate }} {{
                            showBookingOrBLAlert && showVSOUTalert ? '*' : ''
                        }}"
                        contextual="{{
                            showBookingOrBLAlert && showVSOUTalert
                                ? 'Enter one of the mandatory search criteria.'
                                : ('' | translate)
                        }}"
                        formControlName="loadingVoyageNumber"></form-textbox>
                </div>
            }
            @if (releaseOrderId || showUnloadingVoyageNumber) {
                <div class="col-sm-6 col-md-4 col-xl-2">
                    <form-textbox
                        labelText="{{ 'Voyage Number' | translate }}"
                        formControlName="unloadingVoyageNumber"></form-textbox>
                </div>
            }
            <div class="col-sm-6 col-md-4 col-xl-2">
                <form-dropdown
                    labelText="{{ 'Status' | translate }}"
                    formControlName="status"
                    codeListName="ContainerVisitStatus"></form-dropdown>
            </div>
            <div class="col-sm-6 col-md-4 col-xl-2 d-flex justify-content-between align-items-center">
                @if (manipulationId === 'VSOUT') {
                    <form-checkbox
                        class="mr-2 mb-0 d-flex align-items-center flex-nowrap"
                        formControlName="inboundVessels"
                        icon="ship"
                        labelText="{{ 'Include vessel inbound containers' | translate }}"></form-checkbox>
                }

                <div class="d-flex mb-3 flex-nowrap">
                    <button
                        class="btn btn-sm btn-primary mr-2"
                        type="submit"
                        kendoTooltip
                        title="{{ 'Search' | translate }}"
                        [disabled]="isBusy || disabledSearch()">
                        <fa-icon [icon]="['fas', 'search']"></fa-icon>
                    </button>
                    <button
                        class="btn btn-sm btn-secondary"
                        type="button"
                        kendoTooltip
                        title="{{ 'Clear' | translate }}"
                        [disabled]="isBusy"
                        (click)="clearFilter()">
                        <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    </button>
                </div>
            </div>
        </div>
    </form>
    <kendo-grid
        [data]="itemsGridView"
        [loading]="isBusy"
        [skip]="filter.offset"
        [pageSize]="filter.pageSize"
        [sort]="sortsArr"
        [pageable]="pagingOptions"
        [selectable]="selectableSettings"
        [sortable]="{ allowUnsort: true }"
        [resizable]="true"
        [rowClass]="rowCallback"
        [rowSelected]="isRowSelected"
        [kendoGridSelectBy]="selectionCallback"
        [selectedKeys]="selected"
        (pageChange)="pageChange($event)"
        (sortChange)="sortChange($event)"
        (selectedKeysChange)="keyChange($event)">
        <ng-template kendoGridToolbarTemplate>
            <kendo-grid-spacer></kendo-grid-spacer>
            <app-column-configurator
                [columns]="configurableColumns"
                [visibility]="columnConfig.visibility"
                [order]="columnConfig.order"
                (visibilityChange)="columnConfig.onVisibilityChange($event.columnKey, $event.visible)"
                (allVisibilityChange)="columnConfig.setAllVisibility($event)"
                (orderChange)="columnConfig.onOrderChange($event)"
                (resetColumns)="columnConfig.reset()"></app-column-configurator>
        </ng-template>
        <kendo-grid-checkbox-column [width]="40" [headerClass]="'justify-content-center'">
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                <span kendoTooltip title="{{ 'Select All' | translate }}" (click)="selectAllContainerVisits()">
                    @if (selectAll) {
                        <fa-icon size="lg" [icon]="['far', 'check-square']"></fa-icon>
                    }
                    @if (!selectAll) {
                        <fa-icon size="lg" [icon]="['far', 'square']"></fa-icon>
                    }
                    @if (selected.length) {
                        <span>
                            {{ selected.length }}
                        </span>
                    }
                </span>
            </ng-template>
        </kendo-grid-checkbox-column>
        <kendo-grid-column title="{{ 'id ' | translate }}" field="id" [hidden]="true"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Article Nbr.' | translate }}"
            field="articleNumber"
            [width]="130"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('articleNumber')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Container' | translate }}"
            field="container"
            [width]="200"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('container')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Status' | translate }}"
            field="status.id"
            [width]="200"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('status.id')">
            <ng-template let-row kendoGridCellTemplate>
                <div class="row mx-0 flex-nowrap">
                    @if (row.status) {
                        <span
                            class="pill"
                            kendoTooltip
                            title="{{ row.status.name }}"
                            [ngClass]="getClass(row.status.id)">
                            {{ row.status.localizedCode }}
                        </span>
                    }
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            title="{{ 'F/E' | translate }}"
            field="fullOrEmpty"
            [width]="130"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [sortable]="false"
            [hidden]="columnConfig.isHidden('fullOrEmpty')">
            <ng-template kendoGridCellTemplate let-row>
                @if (row.fullOrEmpty === 'F') {
                    <fa-icon
                        kendoTooltip
                        size="lg"
                        title="{{ 'Full' | translate }}"
                        [icon]="CustomIcons.FULL_CONTAINER"></fa-icon>
                }
                @if (row.fullOrEmpty === 'E') {
                    <fa-icon
                        kendoTooltip
                        size="lg"
                        title="{{ 'Empty' | translate }}"
                        [icon]="CustomIcons.EMPTY_CONTAINER"></fa-icon>
                }
                &nbsp;{{ row.fullOrEmpty }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            title="{{ 'ISO' | translate }}"
            field="iso"
            [width]="100"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('iso')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Type' | translate }}"
            field="type"
            [width]="100"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('type')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Length' | translate }}"
            field="length"
            [width]="100"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('length')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Height' | translate }}"
            field="height"
            [width]="100"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('height')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Disch. MOT' | translate }}"
            field="dischargingMeanOfTransport"
            [width]="120"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('dischargingMeanOfTransport')">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i
                    class="fa fa-lg"
                    kendoTooltip
                    title="{{ dataItem.dischargingMeanOfTransportTypeName | translate }}"
                    [ngClass]="getMOTClass(dataItem.dischargingMeanOfTransportTypeId)"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Vessel Voyage Nbr.' | translate }}"
            field="vesselVoyage"
            [width]="120"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [sortable]="false"
            [hidden]="columnConfig.isHidden('vesselVoyage')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Line' | translate }}"
            field="line"
            [width]="120"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('line')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Booking' | translate }}"
            field="booking"
            [width]="200"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('booking')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Bill Of Lading' | translate }}"
            field="billOfLading"
            [width]="200"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('billOfLading')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Nbr. of Packages' | translate }}"
            field="nbrOfPackages"
            [width]="130"
            [headerStyle]="{ 'justify-content': 'end' }"
            [style]="{ 'text-align': 'right' }"
            [hidden]="columnConfig.isHidden('nbrOfPackages')"></kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Gross Weight' | translate }}"
            field="grossWeight"
            [width]="100"
            [headerStyle]="{ 'justify-content': 'end' }"
            [style]="{ 'text-align': 'right' }"
            [hidden]="columnConfig.isHidden('grossWeight')">
            <ng-template kendoGridCellTemplate let-row>
                {{ row.grossWeight | cargoAmount: '1.3-3' : 'de' }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Net Weight' | translate }}"
            field="netWeight"
            [width]="100"
            [headerStyle]="{ 'justify-content': 'end' }"
            [style]="{ 'text-align': 'right' }"
            [hidden]="columnConfig.isHidden('netWeight')">
            <ng-template kendoGridCellTemplate let-row>
                {{ row.netWeight | cargoAmount: '1.3-3' : 'de' }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            title="{{ 'Cargo Description' | translate }}"
            field="cargoDescription"
            [width]="130"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
            [hidden]="columnConfig.isHidden('cargoDescription')">
            <ng-template kendoGridCellTemplate let-dataItem>
                <app-overflow-text [value]="dataItem.cargoDescription"></app-overflow-text>
            </ng-template>
        </kendo-grid-column>
        @if (!!releaseOrderId) {
            <kendo-grid-column
                title="{{ 'Consignee' | translate }}"
                field="consignee"
                [width]="200"
                [headerStyle]="{ 'justify-content': 'center' }"
                [style]="{ 'text-align': 'center' }"
                [sortable]="false"
                [hidden]="columnConfig.isHidden('consignee')"></kendo-grid-column>
        }
        <ng-template kendoGridNoRecordsTemplate>
            <p>{{ 'No records available' | translate }}.</p>
        </ng-template>
    </kendo-grid>
</div>
<div class="modal-footer">
    <button
        class="btn btn-sm btn-primary mr-2"
        [disabled]="isBusy || selected.length < 1 || !yesButtonName || disabledSocImportSelection()"
        (click)="save()">
        {{ yesButtonName }}
    </button>
    <button class="btn btn-sm btn-secondary" translate [disabled]="isBusy" (click)="activeModal.close(null)">
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
        &nbsp;&nbsp;{{ 'Cancel' | translate }}
    </button>
</div>
